/**
 * @fileoverview POST handler for the "/engagement/email_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementEmailTemplatesIdCacheKeys } from "./constants";
import type { PostEngagementEmailTemplatesIdProps, PostEngagementEmailTemplatesIdResponse } from "./types";

export const postEngagementEmailTemplatesId = reactQueryMutationAdapter(
  engagementEmailTemplatesIdCacheKeys,
  (props: PostEngagementEmailTemplatesIdProps): Promise<PostEngagementEmailTemplatesIdResponse> => {
    return fetch(`/engagement/email_templates/${props.id ? `${props.id}` : ""}`, "POST", props);
  }
);
